const { __, _x, _n, _nx } = wp.i18n;

// Bootstrap component list
import { Collapse } from 'bootstrap';

// Utilitaires internes
require('./utilities/class_enlarge.js');
//require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_drilldown_menu.js');
require('./utilities/pdw_modal_search.js');
require('./utilities/pdw_carousel.js');
require('./utilities/pdw_hide_link.js');
require('./utilities/pdw_scrolled.js');
require('./utilities/pdw_lightbox.js');
require('./utilities/pdw_aos.js');
//require('./utilities/gsap/texte_animate.js');
//require('./utilities/gsap/test_anime.js');
//require('./utilities/gsap/test_anime_2.js');
//require('./utilities/test_luge.js');




// require('./utilities/gsap/section_animate');


// require('./utilities/gsap/vertical-loop.js');
//require('./utilities/pdw_woocommerce.js');

// Splide et extension
import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

// Initialisation une fois le DOM prêt
document.addEventListener('DOMContentLoaded', function () {
    // Carrousels avec auto-scroll
    document.querySelectorAll('.splide.auto-scroll').forEach((el) => {
        const options = JSON.parse(el.dataset.splide || '{}');

        new Splide(el, {
            ...options,
            extensions: { AutoScroll },
        }).mount({ AutoScroll });
    });

    // Carrousels sans auto-scroll
    document.querySelectorAll('.splide:not(.auto-scroll)').forEach((el) => {
        const options = JSON.parse(el.dataset.splide || '{}');
        new Splide(el, options).mount();
    });
});



document.addEventListener('DOMContentLoaded', function () {
    const mobileMenu = document.getElementById('pdw-mobile-menu');
    const overlay = document.querySelector('.pdw-mobile-menu-overlay');
    const closeTriggers = document.querySelectorAll('.pdw-mobile-menu-close');

    // Ferme le menu
    function closeMobileMenu() {
        mobileMenu.classList.remove('show');
        document.body.classList.remove('mobile-menu-open');
    }

    //  Clic sur les liens d’ancre du menu mobile (hors GTranslate)
    document.querySelectorAll('.mobile-menu a[href^="#"]').forEach(link => {
        // Ignore si le lien est dans un élément GTranslate
        if (!link.closest('.gt_languages') && !link.closest('.gt_switcher-popup')) {
            link.addEventListener('click', function () {
                closeMobileMenu();
            });
        }
    });

    // Clic sur le bouton de fermeture ou overlay
    closeTriggers.forEach(trigger => {
        trigger.addEventListener('click', function () {
            closeMobileMenu();
        });
    });
});


